var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFryBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "290.3px",
    height: "38px",
    viewBox: "0 0 290.3 38",
    style: {
      enableBackground: "new 0 0 290.3 38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0D3968;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos_x2F_FRY_x5F_blue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M29.5,15.5l-7.8-4.4v10.8v0.3l-3.5,1.9l-6.5-6.4l2.4,8.9l-3.5,2.1l-9.6-5.5V32 c0,3.9,2.8,5.4,6,3.5l22.6-13C32.8,20.5,32.8,17.3,29.5,15.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "st0",
    d: "M17.8,17.9V8.8L7,2.5C3.6,0.6,1,2.1,1,6v12.5L9,23L6.7,12.9l3.7-2.2L17.8,17.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "st0",
    points: "48.9,29.1 44.9,29.1 44.9,8.9 69,8.9 69,12.4 48.9,12.4 48.9,17.2 65.7,17.2 65.7,20.7  48.9,20.7  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    className: "st0",
    d: "M75.6,20h13c1.7,0,2.9-1.1,2.9-2.4v-2.8c0-1.4-1.4-2.4-2.9-2.4h-13V20z M96,29.1h-4.6l-4.7-5.5 H75.5v5.5h-4V8.9h17c3.9,0,7.1,2.8,7.1,6v2.8c0,2.4-1.8,4.6-4.4,5.5L96,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st0",
    d: "M262.7,20h13c1.7,0,2.9-1.1,2.9-2.4v-2.8c0-1.4-1.4-2.4-2.9-2.4h-13V20z M283.2,29.1h-4.6 l-4.7-5.5h-11.2v5.5h-4V8.9h17c3.9,0,7.1,2.8,7.1,6v2.8c0,2.4-1.8,4.6-4.4,5.5L283.2,29.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "st0",
    points: "110,29.1 106,29.1 106,22.7 95.6,8.9 100,8.9 107.9,19 115.8,8.9 120.4,8.9 110,22.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "st0",
    points: "149.7,29.1 145.7,29.1 145.7,15.3 136,26.9 126.3,15.3 126.3,29.1 122.3,29.1  122.3,8.9 126.2,8.9 126.3,9 136,20.8 145.8,9 149.7,9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st0",
    d: "M157.5,20h15.9v-5.3c0-1.4-1.4-2.4-3-2.4h-10c-1.7,0-2.9,1.1-2.9,2.4V20z M177.5,29.1h-4.2v-5.5 h-15.9v5.5h-4V14.8c0-3.2,3.2-6,7.1-6h10c3.7,0,6.9,2.6,7.1,6V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st0",
    d: "M197.3,29.1h-10c-3.9,0-6.9-2.6-7.1-6v-0.4h4v0.4c0,1.4,1.4,2.4,3,2.4h10c1.7,0,2.9-1.1,2.9-2.4 c0-1.4-1.4-2.4-2.9-2.4h-10c-3.9,0-7.1-2.6-7.1-6c0-3.2,3.2-6,7.1-6h10c3.7,0,6.9,2.6,7.1,6v0.4h-4.2v-0.4c0-1.4-1.4-2.4-2.9-2.4 h-10c-1.7,0-3,1.1-3,2.4c0,1.4,1.4,2.4,3,2.4h10c3.9,0,7.1,2.8,7.1,6S201.2,29.1,197.3,29.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-19",
    className: "st0",
    points: "219.4,29.1 215.3,29.1 215.3,12.5 205.2,12.5 205.2,9 229.3,9 229.3,12.5 219.4,12.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    className: "st0",
    points: "255.8,29.1 231.7,29.1 231.7,8.9 255.8,8.9 255.8,12.4 235.7,12.4 235.7,17.2  252.4,17.2 252.4,20.7 235.7,20.7 235.7,25.5 255.8,25.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-23",
    className: "st0",
    d: "M286.4,10.3h0.2c0.3,0,0.6-0.1,0.6-0.3c0-0.2-0.2-0.3-0.5-0.3h-0.3V10.3z M286.4,11.6h-0.6V9.3 c0.2-0.1,0.5-0.1,0.9-0.1c0.4,0,0.7,0.1,0.8,0.2c0.2,0.1,0.2,0.2,0.2,0.5s-0.2,0.5-0.5,0.6c0.2,0.1,0.3,0.2,0.4,0.6 c0.1,0.3,0.1,0.5,0.2,0.6h-0.6c-0.1-0.1-0.1-0.3-0.2-0.6c-0.1-0.2-0.2-0.4-0.5-0.4h-0.2V11.6z M285,10.4c0,1.1,0.7,1.9,1.8,1.9 c1.1,0,1.8-0.8,1.8-1.9c0-1.1-0.7-1.9-1.8-1.9C285.7,8.5,285,9.4,285,10.4z M289.1,10.4c0,1.3-1.1,2.4-2.4,2.4s-2.4-1.1-2.4-2.4 s1.1-2.4,2.4-2.4S289.1,9.1,289.1,10.4z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFryBlue);
export default __webpack_public_path__ + "static/media/FRY_blue.28d221c07f2bfcad62c7d84dee506dc9.svg";
export { ForwardRef as ReactComponent };